import type {
	ApplicationLocation,
	ApplicationMethod
} from "@lib/analyticsTypes";

export function clarityFireApplicationEvent(
	job_uuid: string,
	company_uuid: string,
	application_method: ApplicationMethod,
	application_location: ApplicationLocation
) {
	if (typeof window.clarity !== "function") {
		console.error("Clarity is not loaded or initialized.");
	}
	try {
		window.clarity("set", "job_uuid", job_uuid);
		window.clarity("set", "company_uuid", company_uuid);
		window.clarity("set", "application_method", application_method);
		window.clarity("set", "application_location", application_location);

		//keep same event name not user_applied
		window.clarity("event", "User applied");
	} catch (err) {
		console.log("Function clarityFireApplicationEvent failed:", err);
	}
}

export function clarityFireSubscriptionEvent() {
	if (typeof window.clarity !== "function") {
		console.error("Clarity is not loaded or initialized.");
	}
	try {
		//keep same event name not user_applied
		window.clarity("event", "User subscribed to job alert");
	} catch (err) {
		console.log("Function clarityFireApplicationEvent failed:", err);
	}
}
